import { DateObject } from "react-multi-date-picker";
import gregorian from "react-date-object/calendars/gregorian";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

function hasTime(date: string): boolean {
    return !!(date && date.includes("T") && date.includes(":"));
}

export default function ConvertDateToFa(date: string): string {
    if (!date) return "";

    const data = new DateObject({
        calendar: gregorian,
        date: new Date(date),
        locale: persian_fa,
        format: "YYYY/MM/DD HH:mm:ss",
    }).convert(persian);

    const formatString = hasTime(date) ? "YYYY/MM/DD HH:mm" : "YYYY/MM/DD";
    return data.format(formatString);
}
